import React from 'react';
import PropTypes from 'prop-types';

class FilterSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: props.initialValue, }
    }

    handleChange(event) {
        const { multiple } = this.props.selectProps;

        let value = multiple ? []: null;
        if (multiple) {
            const { options } = event.target;
            for (let i = 0, l = options.length; i < l; i++) {
                if (options[i].selected) {
                    value.push(options[i].value);
                }
            }
        } else {
            value = event.target.value;
        }

        this.setState({ value });
        this.props.onChange(value);
    }

    render() {
        const { label, options, selectProps } = this.props;
        const selectName = 'select-filter';
        return (
            <div className="select-filter inline">
                {label && [
                    <label key="select-filter-label-1" htmlFor={selectName}>{label}</label>,
                    <br key="select-filter-label-2"/>,
                ]}
                <select
                    name={selectName}
                    className="form-control"
                    disabled={options.length < 1}
                    onChange={this.handleChange.bind(this)}
                    value={this.state.value}
                    {...selectProps}
                >
                    {options.length < 1 && <option value={null}>Waiting for data...</option>}
                    {options.map(({ value, text, ...rest }) => (
                        <option key={value} value={value} {...rest}>{text}</option>
                    ))}
                </select>
            </div>
        )
    }
}

FilterSelect.propTypes = {
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, value: PropTypes.string })),
    selectProps: PropTypes.object,
};

FilterSelect.defaultProps = {
    initialValue: null,
    options: [],
    selectProps: {},
};

export default FilterSelect



// WEBPACK FOOTER //
// ./src/components/Filters/Select/index.js